var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"icon":_vm.btnIcon,"id":"btn-fold","size":"mini"},on:{"click":_vm.foldAside}})
}
var staticRenderFns = []

export { render, staticRenderFns }